// extracted by mini-css-extract-plugin
export default {"title":"V--z","warning":"W--z","sizeOptionsLegendText":"X--z"};